// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XC_W","content":"styles_content__2zbdg","row":"styles_row__17Nlw","footer":"styles_footer__vLD3K","phraseLength":"styles_phraseLength__wQIqj"};